import { useNavigate } from "react-router-dom";
import shopping_cart from "../../assets/images/icons/Shopping_cart.svg";
import search from "../../assets/images/icons/Search.svg";
import account_circle from "../../assets/images/icons/Account_circle.svg";
import { useAuth } from "../../hooks/useAuth";
import { useCart } from "../../context/CartContext";
import { useLocalizedNavigation } from "../../hooks/useLocalizedNavigation";
import { withLocalePath } from "../../utils/localeRouting";

export const HeaderIcons = ({ activePanel, onTogglePanel }) => {
  const { isAuthenticated, language, setLanguage, user } = useAuth();
  const { cartItems } = useCart();
  const navigate = useNavigate();
  const { pathnameWithoutLocale } = useLocalizedNavigation();

  const getInitials = (fullName) => {
    if (!fullName || typeof fullName !== "string") {
      return "";
    }

    const names = fullName.trim().split(/\s+/);

    if (names.length === 0) return "";
    if (names.length === 1) return names[0][0]?.toUpperCase() || "";

    return (names[0][0] + names[names.length - 1][0]).toUpperCase();
  };

  return (
    <div className="header__icons header__desktop">
      <li className="cart-icon language-selector-wrapper">
        <select
          className="language-selector"
          value={language}
          onChange={(event) => {
            const nextLanguage = event.target.value;
            setLanguage(nextLanguage);
            navigate(withLocalePath(pathnameWithoutLocale, nextLanguage));
          }}
        >
          <option value="pt">PT</option>
          <option value="en">EN</option>
          <option value="es">ES</option>
          <option value="fr">FR</option>
        </select>
      </li>
      <li
        className={activePanel === "cart" ? "active cart-icon" : "cart-icon"}
        onClick={() => onTogglePanel("cart")}
        style={{ position: "relative" }}
      >
        <img src={shopping_cart} alt="Shopping Cart" />
        {cartItems.length > 0 && <span className="cart-badge">{cartItems.length}</span>}
      </li>

      <li
        className={activePanel === "search" ? "active" : ""}
        onClick={() => onTogglePanel("search")}
      >
        <img src={search} alt="Search" />
      </li>

      <li
        className={activePanel === "auth" ? "active" : ""}
        onClick={() => {
          if (isAuthenticated) {
            navigate(withLocalePath("/account", language));
            return;
          }

          onTogglePanel("auth");
        }}
      >
        {isAuthenticated ? (
          <p className="user-initials">{getInitials(user?.fullName)}</p>
        ) : (
          <img src={account_circle} alt="Account" />
        )}
      </li>
    </div>
  );
};
